import { render } from "./PainelFull.vue?vue&type=template&id=6cc7e14a&scoped=true"
const script = {}

import "./PainelFull.vue?vue&type=style&index=0&id=6cc7e14a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cc7e14a"]])

export default __exports__